import { getTrackById } from "../assets/asset_loaders/tracks"
import './CupTrack.css'

const CupTrack = (props) => {

  const start = props?.start ? getTrackById(props?.start) : null;
  const end = props?.end ? getTrackById(props?.end) : null;

  return <div className="cuptrack">
    {
      !start ? <p>Select a track</p> :
        end !== null ? <div className="cuptrack-dual-container">
          <TrackImgCrop
            src={start.courseimg}
            alt={start.name}
            crop="left"
          />
          <TrackImgCrop
            src={end.courseimg}
            alt={end.name}
            crop="right"
          />
          <span className="cuptrack-arrow">&rarr;</span>
        </div>
          : <TrackImg
            src={start.courseimg}
            alt={start.name}
          />
    }
  </div>
}

export default CupTrack;

// helper components to render

const TrackImg = (props) => {
  return <img
    src={props.src}
    alt={props.alt}
    className="track-img"
    crossOrigin="anonymous"
  />
}

const TrackImgCrop = (props) => {
  return <img
    src={props.src}
    alt={props.alt}
    className={`track-img-crop ${props.crop}`}
    crossOrigin="anonymous"
  />
}